import { render, staticRenderFns } from "./TjingButton.vue?vue&type=template&id=02f912e3&scoped=true"
import script from "./TjingButton.vue?vue&type=script&lang=js"
export * from "./TjingButton.vue?vue&type=script&lang=js"
import style0 from "./TjingButton.vue?vue&type=style&index=0&id=02f912e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f912e3",
  null
  
)

export default component.exports